import * as Actions from '../../../Modules/CmsActions'
import type { Notification } from '../../../Types'

const initialState: Notification[] = []

const NotificationReducer = (state = initialState, action) => {
  const { type, payload, error } = action

  switch (type) {
    case Actions.REQUEST_FETCH_ALL_NOTIFICATION:
      return { ...state }

    case Actions.FINISH_FETCH_ALL_NOTIFICATION:
      return error ? { ...state } : createServices(payload.integration)

    default:
      return state
  }
}

function createServices(integration: any[]): any[] {
  return integration
    .filter((info) => info.type === 'Twitter' || info.type === 'Facebook')
    .map((info, index) => {
      return {
        type: info.type,
      }
    })
}

export default NotificationReducer
